/* eslint-disable max-len */
import 'react';

let index = 0;
const DocumentSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const timeStamp = index++;
    const id = `DocumentSvg-1-${timeStamp}`;
    const id2 = `DocumentSvg-2-${timeStamp}`;

    return (
        <svg width="1em" height="1em" viewBox="0 0 26 26" {...props}>
            <defs>
                <linearGradient
                    x1="15.244%"
                    y1="0%"
                    x2="84.756%"
                    y2="55.407%"
                    id={id}
                >
                    <stop stopColor="#5CB8FF" offset="0%" />
                    <stop stopColor="#5C97FF" offset="100%" />
                </linearGradient>
                <linearGradient
                    x1="50%"
                    y1="0%"
                    x2="50%"
                    y2="81.112%"
                    id={id2}
                >
                    <stop stopColor="#FFF" stopOpacity={0.96} offset="0%" />
                    <stop stopColor="#FFF" stopOpacity={0.8} offset="100%" />
                </linearGradient>
            </defs>
            <g fill="none" fillRule="evenodd">
                <path d="M2.786 3.493h20.429v20.429H2.785z" />
                <path
                    d="M0 1.247C0 .558.558 0 1.247 0h12.055a5.278 5.278 0 015.278 5.278v14.514a2.494 2.494 0 01-2.493 2.494H2.494A2.494 2.494 0 010 19.792V1.247z"
                    fill={`url(#${id})`}
                    transform="translate(3.714 2.1)"
                />
                <path
                    d="M13.334 15.168a.726.726 0 110 1.451H4.336a.726.726 0 010-1.45h8.998zm-2.554-4.24a.726.726 0 110 1.452H4.336a.726.726 0 010-1.451h6.444zm-.232-4.238a.726.726 0 110 1.45H4.336a.726.726 0 110-1.45h6.212z"
                    fill={`url(#${id2})`}
                    transform="translate(3.714 2.1)"
                />
            </g>
        </svg>
    );
};
export default DocumentSvg;
